import { NextRouter } from 'next/router'

import { SanityPrintShopBase } from '@data/sanity/queries/types/shop'
import { getPageUrl, PageType, PageUrlOptions } from '@lib/routes'
import { variantUrlParameterName } from '@lib/url'

/**
 * Gets correct URL for any print shop page.
 */
export const getPrintShopPageUrl = (
  router: NextRouter,
  printShop: SanityPrintShopBase,
) => {
  const printShopSlug = router.query.id as string | undefined
  const productSlug = router.query.slug as string | undefined
  // Note: Next.js router query does not always contain URL parameter values on page load, they are sometimes
  // filled in later, so it is safer to take them from path instead.
  const origin =
    typeof window !== 'undefined' && window.location.origin
      ? window.location.origin
      : 'https://example.com'
  const url = new URL(`${origin}${router.asPath}`)
  const variant = url.searchParams.get(variantUrlParameterName)
  const urlOptions: PageUrlOptions = {
    parameters: {
      [variantUrlParameterName]: variant ?? '',
    },
  }

  const isShopProductPrintPage =
    !!printShopSlug &&
    !!productSlug &&
    !!router.route.startsWith('/shop/team') &&
    !!router.route.includes('/print')
  const isShopProductPage =
    !!printShopSlug &&
    !!productSlug &&
    !!router.route.startsWith('/shop/team') &&
    !router.route.includes('/print')
  const isShopPage =
    !!printShopSlug &&
    !productSlug &&
    !!router.route.startsWith('/shop/team') &&
    !router.route.includes('/print')

  if (isShopProductPrintPage) {
    return getPageUrl(
      PageType.SHOP_PRODUCT_PRINT,
      [printShop.slug, productSlug],
      urlOptions,
    )
  }

  if (isShopProductPage) {
    return getPageUrl(
      PageType.SHOP_PRODUCT,
      [printShop.slug, productSlug],
      urlOptions,
    )
  }

  if (isShopPage) {
    return getPageUrl(PageType.PRIVATE_SHOP_PAGE, [printShop.slug])
  }
}
